import { useMutation } from 'react-query';
import {useWordPressStore} from "../../store/wordpress.store";
import {WordpressApi} from "../../api/wordpress.api";

export const useWordPressCategories = () => {
    const setCategories = useWordPressStore((state) => state.setCategories);

    return useMutation(WordpressApi.getCategories, {
        onSuccess: (data) => {
            setCategories(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};